const localStorageKey = "warrantyModalClose";

const getModalData = () => JSON.parse(window.localStorage.getItem(localStorageKey)) || { date: null, count: 0 };
const setModalData = (data) => window.localStorage.setItem(localStorageKey, JSON.stringify(data));

export const updateCloseCount = () => {
	const closeData = getModalData();
	closeData.count++;
	setModalData(closeData);
};

export const warrantyCloseData = () => {
	const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format
	let { date, count } = getModalData();

	if (date !== today) {
		date = today;
		count = 0;
		setModalData({ date, count });
	}

	return { date, count };
};